module.exports = __webpack_public_path__ + "img/waving-hand.63a7a73b.png";